<div class="contentful-wrapper-navigation">
  <tpm-tabs
    *ngIf="contentTypeToggles?.length"
    variant="primary"
    data-cy="contentful-tabs"
    indicator="bottom"
    class="contentful-wrapper-navigation__tabs"
    [tabs]="contentTypeTabs"
    [active]="contentType"
    (activeTabChange)="onContentTypeChange($event)"
    (activeTabChangeInitially)="onContentTypeChange($event)"
  ></tpm-tabs>
  <div class="contentful-wrapper-navigation__row">
    <tpm-select
      *ngIf="!useChipSet && moduleSelectOptions?.length"
      class="module-select"
      appearance="outline"
      [options]="moduleSelectOptions"
      [ngModel]="selectedModule"
      (changed)="moduleChange.emit($event ? [$event] : [])"
    ></tpm-select>
    <tpm-text-field
      class="search-field"
      name="search"
      [placeholder]="'GLOSSARY_DIALOG.searchPlaceholder' | translate"
      [icon]="'gpi-filled-search-alt'"
      (ngModelChange)="onSearchChange($event)"
    ></tpm-text-field>
  </div>
  <div class="chips-set" *ngIf="useChipSet && moduleSelectOptions?.length">
    <tpm-chip-set
      [chips]="moduleChips"
      [active]="activeFilters()"
      (selected)="onModuleChipsChange($event)"
    ></tpm-chip-set>
  </div>
</div>
